/**
 * Continuous Improvement Types
 *
 * Central type definitions for the Continuous Improvement feature.
 * All enums, interfaces, and type aliases live here.
 */

import type { Dataset } from "@functions/state/types";

/**
 * Result of evaluating whether continuous improvement should trigger.
 * Written to rapid_data.lastCIEvaluation so the frontend can react in real-time.
 */
export enum CIEvaluationResult {
    INSUFFICIENT_CREDITS = "insufficient_credits",
    TRAINING_SCHEDULED = "training_scheduled",
    TRAINING_IN_PROGRESS = "training_in_progress",
    TRAINING_COMPLETED = "training_completed",
    TRAINING_FAILED = "training_failed"
}

/**
 * Status of continuous improvement for a dataset
 */
export enum ContinuousImprovementStatus {
    ENABLED = "enabled",
    DISABLED = "disabled",
    PAUSED = "paused"
}

/**
 * Configuration for continuous improvement on a dataset
 */
export interface ContinuousImprovementConfig {
    status: ContinuousImprovementStatus;
}

/**
 * Context passed to continuous improvement evaluation functions.
 * Contains everything needed to evaluate and trigger continuous improvement.
 * Functions should receive this context rather than individual pieces.
 */
export interface ContinuousImprovementContext {
    datasetBefore: Dataset;
    datasetAfter: Dataset;
    config: ContinuousImprovementConfig;
}
